import { mainAxiosClient } from "./axiosBaseClient";
import apiConfig from './routesApi';

const dialerApi = {
    getModes: () => {
        const url = apiConfig.apiDialer.getModes;
        return mainAxiosClient.get(url);
    },
    updateActiveMode: (modeId) => {
        const url = apiConfig.apiDialer.updateActiveMode + modeId;
        return mainAxiosClient.post(url);
    },
}

export default dialerApi;